// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_section {
  position: fixed;
  height: 100%;
  z-index: 9;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
}
#MessageContainer {
  resize: none;
}
.gap-lg-2 {
  gap: 20px;
}
.gap-lg-1 {
  gap: 10px;
}
.ask_ai input::placeholder {
  font-size: 1rem;
  font-weight: 500;
}
.ask_ai #MessageContainer {
  height: 4rem;
  font-size: 16px;
  color: #000;
}
.ask_ai #chat__bodyview .primaryicon-right-arrow,
.ask_ai #chat__bodyview .primaryicon-left-arrow {
  width: 20px;
  height: 43px;
  border-radius: 3px;
  margin: 0;
  padding: 5px !important;
  font-size: 12px;
  z-index: 99;
  position: absolute;
}
.ask_ai #chat__bodyview .primaryicon-right-arrow {
  right: -20px !important;
}
.ask_ai #chat__bodyview .primaryicon-left-arrow {
  left: -20px !important;
}
.ask_ai #chat__bodyview .v-slick-slider em[disabled=false] {
  display: none !important;
}
.ask_ai #chat__bodyview .v-slick-dots li button:before {
  font-size: 16px;
}
.ask_ai p {
  font-size: 14px;
}
.ask_ai .shadow-sm {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px !important;
}
.ask_ai .strip_input {
  font-weight: bold;
}
.ask_ai .svg_icon svg {
  height: auto !important;
}
.ask_ai .transparent-bgcolor {
  background: rgba(0, 0, 0, 0.2) !important;
}
.ask_ai .transparent-bg {
  background: rgba(255, 255, 255, 0.1) !important;
}
.ask_ai .transparent-bgcolor-light {
  background: rgba(0, 0, 0, 0.1) !important;
}
.ask_ai .gradient_text_white {
  color: #fff !important;
}
.ask_ai .cursor_pointer {
  cursor: pointer !important;
}
.ask_ai .rounded_10 {
  border-radius: 10px !important;
}
.ask_ai .primary-close-circle_icon {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ask_ai .primary-close-circle_icon em {
  top: 0;
}
.ask_ai .footer_icon {
  font-size: 13px;
  padding: 7px 16px;
}
.ask_ai .footer_icon.rounded-buttons {
  font-family: inherit !important;
  font-weight: normal !important;
}
.ask_ai .footer_icon:hover {
  background: #fff !important;
  transition: all 0.3s ease;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.ask_ai .footer_icon:hover .hover_black {
  color: #000 !important;
}
.ask_ai div[disabled=true] {
  opacity: 0.9;
  pointer-events: none;
}
.border_horizontal {
  width: 1px;
  height: 2.5rem;
  background: #000;
  display: block;
}
.expandable-content {
  flex-grow: 1;
  background: #f9f9f9;
  border-radius: 0 0;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  right: 0;
  height: calc(100vh - 100px);
  z-index: 98;
  max-width: 75%;
  margin: auto;
}
.classicDesign .conversation_container,
.classicDesign .chat_input_container {
  width: 70%;
  margin: auto;
}
.classicDesign .chat_input_container {
  margin-top: 15px;
}
.expand-enter-active,
.expand-leave-active {
  transition: height 0.5s ease, opacity 0.5s ease;
  overflow: hidden;
}
.expand-enter,
.expand-leave-to {
  height: 0;
  opacity: 0;
}
.conversation_container {
  overflow-y: auto;
}
.chat_input_container {
  background: #fff;
  margin-bottom: 10px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 15px;
  padding: 10px;
}
.custom_box_shadow {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  z-index: 1;
}
.send_icon {
  height: 40px;
  width: 40px;
  border-radius: 7px;
  font-size: 17px;
}
.send_icon em {
  display: inline;
  color: #fff;
  transform: rotate(270deg);
}
.cursor_pointer {
  cursor: pointer;
}
.close_icon_container {
  right: 15px;
  z-index: 9;
}
.service__types__btn h6 {
  font-size: 12px;
}
@media (min-width: 1920px) and (max-width: 2399px) {
.ask_ai .strip_input {
    font-size: 26px !important;
}
.ask_ai p {
    font-size: 17px !important;
}
.ask_ai .footer_icon {
    font-size: 13px !important;
    padding: 7px 16px;
}
.service__types__btn h6 {
    font-size: 15px;
}
}
.footer_icon {
  background: #eee;
  font-size: 12px;
}
.send_container {
  gap: 15px;
}
.bar-slide-enter-active,
.bar-slide-leave-active,
.window-slide-enter-active,
.window-slide-leave-active,
.input-slide-enter-active,
.input-slide-leave-active {
  transition: transform ease;
}
.bar-slide-enter-active,
.bar-slide-leave-active {
  transition-duration: 0.4s;
}
.window-slide-enter-active,
.window-slide-leave-active {
  transition-duration: 0.5s;
}
.input-slide-enter-active,
.input-slide-leave-active {
  transition-duration: 0.3s;
}
.bar-slide-enter-from,
.bar-slide-leave-to,
.window-slide-enter-from,
.window-slide-leave-to {
  transform: translateY(-100%);
}
.bar-slide-enter-to,
.bar-slide-leave-from,
.window-slide-enter-to,
.window-slide-leave-from,
.input-slide-enter-to,
.input-slide-leave-from {
  transform: translateY(0);
}
.input-slide-enter-from,
.input-slide-leave-to {
  transform: translateY(100%);
}
.primary-close-circle_icon {
  border-radius: 24px;
  border: 0;
  padding: 8px 10px;
  font-size: 10px;
  text-align: center;
  display: inline-block;
}
.arrow_down {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.arrow_down em {
  transform: rotate(90deg);
}
.voice-animation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.c_border {
  border: 1px solid #f9f9f9;
}
.is_gradient .custom_box_shadow {
  box-shadow: none !important;
}
.is_gradient .ai_bg_card {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
}
.is_gradient .ai_bg_card a {
  color: #fff !important;
}
.is_gradient .btn.transparent-bgcolor,
.is_gradient .service__chips__btn,
.is_gradient .suggestions_btn {
  background: transparent !important;
  color: #fff !important;
  border: 1px solid rgba(255, 255, 255, 0.7) !important;
}
.is_gradient .v-slick-slide-group .transparent-bgcolor {
  background: rgba(0, 0, 0, 0.2) !important;
  color: #fff !important;
  border: 0px solid rgba(255, 255, 255, 0.7) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AssistantAi.less","webpack://./AssistantAi.vue"],"names":[],"mappings":"AAQA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;ACPF;ADUA;EACE,YAAA;ACRF;ADWA;EACE,SAAA;ACTF;ADYA;EACE,SAAA;ACVF;ADaA;EAEI,eAAA;EACA,gBAAA;ACZJ;ADSA;EAOI,YAAA;EACA,eAAA;EACA,WAAA;ACbJ;ADIA;;EAiBM,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;ACjBN;ADPA;EA4BM,uBAAA;AClBN;ADVA;EAgCM,sBAAA;ACnBN;ADbA;EAoCM,wBAAA;ACpBN;ADhBA;EAwCM,eAAA;ACrBN;ADnBA;EA6CI,eAAA;ACvBJ;ADtBA;EAiDI,4DAAA;ACxBJ;ADzBA;EAsDI,iBAAA;AC1BJ;AD5BA;EA2DM,uBAAA;AC5BN;AD/BA;EAgEI,yCAAA;AC9BJ;ADlCA;EAoEI,+CAAA;AC/BJ;ADrCA;EAwEI,yCAAA;AChCJ;ADxCA;EA4EI,sBAAA;ACjCJ;AD3CA;EAgFI,0BAAA;AClCJ;AD9CA;EAoFI,8BAAA;ACnCJ;ADjDA;EAwFI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACpCJ;ADxDA;EA+FM,MAAA;ACpCN;AD3DA;EAoGI,eAAA;EACA,iBAAA;ACtCJ;ADwCI;EACE,+BAAA;EACA,8BAAA;ACtCN;ADyCI;EACE,2BAAA;EACA,yBAAA;EACA,iDAAA;ACvCN;ADoCI;EAMI,sBAAA;ACvCR;AD3EA;EAwHI,YAAA;EACA,oBAAA;AC1CJ;AD8CA;EACE,UAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AC5CF;AD+CA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AC7CF;ADgDA;;EAGI,UAAA;EACA,YAAA;AC/CJ;AD2CA;EAQI,gBAAA;AChDJ;ADoDA;;EAEE,+CAAA;EACA,gBAAA;AClDF;ADqDA;;EAEE,SAAA;EACA,UAAA;ACnDF;ADsDA;EACE,gBAAA;ACpDF;ADuDA;EACE,gBAAA;EACA,mBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;ACrDF;ADwDA;EACE,iDAAA;EACA,UAAA;ACtDF;ADyDA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;ACvDF;ADmDA;EAOI,eAAA;EACA,WAAA;EACA,yBAAA;ACvDJ;AD2DA;EACE,eAAA;ACzDF;AD4DA;EACE,WAAA;EACA,UAAA;AC1DF;AD6DA;EAEI,eAAA;AC5DJ;ADgEA;AACE;IAEI,0BAAA;AC/DJ;AD6DA;IAMI,0BAAA;AChEJ;AD0DA;IAUI,0BAAA;IACA,iBAAA;ACjEJ;ADqEA;IAEI,eAAA;ACpEJ;AACF;ADwEA;EACE,gBAAA;EACA,eAAA;ACtEF;ADyEA;EACE,SAAA;ACvEF;AD2EA;;;;;;EAME,0BAAA;ACzEF;AD4EA;;EAEE,yBAAA;AC1EF;AD6EA;;EAEE,yBAAA;AC3EF;AD8EA;;EAEE,yBAAA;AC5EF;AD+EA;;;;EAIE,4BAAA;AC7EF;ADgFA;;;;;;EAME,wBAAA;AC9EF;ADiFA;;EAEE,2BAAA;AC/EF;ADkFA;EACE,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AChFF;ADmFA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;ACjFF;AD2EA;EASI,wBAAA;ACjFJ;ADqFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;ACnFF;ADsFA;EACE,yBAAA;ACpFF;ADyFA;EAEI,2BAAA;ACxFJ;ADsFA;EAKI,+CAAA;EACA,sBAAA;ACxFJ;ADkFA;EAQM,sBAAA;ACvFN;AD+EA;;;EAYI,kCAAA;EACA,sBAAA;EACA,qDAAA;ACtFJ;ADwEA;EAiBI,yCAAA;EACA,sBAAA;EACA,qDAAA;ACtFJ","sourcesContent":["@black-transparent-70: rgba(0, 0, 0, 0.7);\n@white-transparent-10: rgba(255, 255, 255, 0.1);\n@black-transparent-10: rgba(0, 0, 0, 0.1);\n@black-transparent-20: rgba(0, 0, 0, 0.2);\n@black-transparent-40: rgba(0, 0, 0, 0.4);\n@box-shadow-light: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n@white-transparent-70: rgba(255, 255, 255, 0.7);\n\n.overlay_section {\n  position: fixed;\n  height: 100%;\n  z-index: 9;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  background-color: @black-transparent-70;\n}\n\n#MessageContainer {\n  resize: none;\n}\n\n.gap-lg-2 {\n  gap: 20px;\n}\n\n.gap-lg-1 {\n  gap: 10px;\n}\n\n.ask_ai {\n  input::placeholder {\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  #MessageContainer {\n    height: 4rem;\n    font-size: 16px;\n    color: #000;\n  }\n\n\n  #chat__bodyview {\n\n    .primaryicon-right-arrow,\n    .primaryicon-left-arrow {\n      width: 20px;\n      height: 43px;\n      border-radius: 3px;\n      margin: 0;\n      padding: 5px !important;\n      font-size: 12px;\n      z-index: 99;\n      position: absolute;\n    }\n\n    .primaryicon-right-arrow {\n      right: -20px !important;\n    }\n\n    .primaryicon-left-arrow {\n      left: -20px !important;\n    }\n\n    .v-slick-slider em[disabled=false] {\n      display: none !important;\n    }\n\n    .v-slick-dots li button:before {\n      font-size: 16px;\n    }\n  }\n\n  p {\n    font-size: 14px;\n  }\n\n  .shadow-sm {\n    box-shadow: @box-shadow-light !important;\n  }\n\n\n  .strip_input {\n    font-weight: bold;\n  }\n\n  .svg_icon {\n    svg {\n      height: auto !important;\n    }\n  }\n\n  .transparent-bgcolor {\n    background: @black-transparent-20 !important;\n  }\n\n  .transparent-bg {\n    background: @white-transparent-10 !important;\n  }\n\n  .transparent-bgcolor-light {\n    background: @black-transparent-10 !important;\n  }\n\n  .gradient_text_white {\n    color: #fff !important;\n  }\n\n  .cursor_pointer {\n    cursor: pointer !important;\n  }\n\n  .rounded_10 {\n    border-radius: 10px !important;\n  }\n\n  .primary-close-circle_icon {\n    width: 35px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    em {\n      top: 0;\n    }\n  }\n\n  .footer_icon {\n    font-size: 13px;\n    padding: 7px 16px;\n\n    &.rounded-buttons {\n      font-family: inherit !important;\n      font-weight: normal !important;\n    }\n\n    &:hover {\n      background: #fff !important;\n      transition: all 0.3s ease;\n      box-shadow: @box-shadow-light;\n\n      .hover_black {\n        color: #000 !important;\n      }\n    }\n  }\n\n  div[disabled=true] {\n    opacity: 0.9;\n    pointer-events: none;\n  }\n}\n\n.border_horizontal {\n  width: 1px;\n  height: 2.5rem;\n  background: #000;\n  display: block;\n}\n\n.expandable-content {\n  flex-grow: 1;\n  background: #f9f9f9;\n  border-radius: 0 0;\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  left: 0;\n  right: 0;\n  height: calc(100vh - 100px);\n  z-index: 98;\n  max-width: 75%;\n  margin: auto;\n}\n\n.classicDesign {\n  .conversation_container,\n  .chat_input_container {\n    width: 70%;\n    margin: auto;\n  }\n\n  .chat_input_container {\n    margin-top: 15px;\n  }\n}\n\n.expand-enter-active,\n.expand-leave-active {\n  transition: height 0.5s ease, opacity 0.5s ease;\n  overflow: hidden;\n}\n\n.expand-enter,\n.expand-leave-to {\n  height: 0;\n  opacity: 0;\n}\n\n.conversation_container {\n  overflow-y: auto;\n}\n\n.chat_input_container {\n  background: #fff;\n  margin-bottom: 10px;\n  box-shadow: @box-shadow-light;\n  border-radius: 15px;\n  padding: 10px;\n}\n\n.custom_box_shadow {\n  box-shadow: @box-shadow-light;\n  z-index: 1;\n}\n\n.send_icon {\n  height: 40px;\n  width: 40px;\n  border-radius: 7px;\n  font-size: 17px;\n\n  em {\n    display: inline;\n    color: #fff;\n    transform: rotate(270deg);\n  }\n}\n\n.cursor_pointer {\n  cursor: pointer;\n}\n\n.close_icon_container {\n  right: 15px;\n  z-index: 9;\n}\n\n.service__types__btn {\n  h6 {\n    font-size: 12px;\n  }\n}\n\n@media (min-width: 1920px) and (max-width: 2399px) {\n  .ask_ai {\n    .strip_input {\n      font-size: 26px !important;\n    }\n\n    p {\n      font-size: 17px !important;\n    }\n\n    .footer_icon {\n      font-size: 13px !important;\n      padding: 7px 16px;\n    }\n  }\n\n  .service__types__btn {\n    h6 {\n      font-size: 15px;\n    }\n  }\n}\n\n.footer_icon {\n  background: #eee;\n  font-size: 12px;\n}\n\n.send_container {\n  gap: 15px;\n}\n\n// Transitions\n.bar-slide-enter-active,\n.bar-slide-leave-active,\n.window-slide-enter-active,\n.window-slide-leave-active,\n.input-slide-enter-active,\n.input-slide-leave-active {\n  transition: transform ease;\n}\n\n.bar-slide-enter-active,\n.bar-slide-leave-active {\n  transition-duration: 0.4s;\n}\n\n.window-slide-enter-active,\n.window-slide-leave-active {\n  transition-duration: 0.5s;\n}\n\n.input-slide-enter-active,\n.input-slide-leave-active {\n  transition-duration: 0.3s;\n}\n\n.bar-slide-enter-from,\n.bar-slide-leave-to,\n.window-slide-enter-from,\n.window-slide-leave-to {\n  transform: translateY(-100%);\n}\n\n.bar-slide-enter-to,\n.bar-slide-leave-from,\n.window-slide-enter-to,\n.window-slide-leave-from,\n.input-slide-enter-to,\n.input-slide-leave-from {\n  transform: translateY(0);\n}\n\n.input-slide-enter-from,\n.input-slide-leave-to {\n  transform: translateY(100%);\n}\n\n.primary-close-circle_icon {\n  border-radius: 24px;\n  border: 0;\n  padding: 8px 10px;\n  font-size: 10px;\n  text-align: center;\n  display: inline-block;\n}\n\n.arrow_down {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n\n  em {\n    transform: rotate(90deg);\n  }\n}\n\n.voice-animation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.c_border {\n  border: 1px solid #f9f9f9;\n}\n\n\n\n.is_gradient{\n  .custom_box_shadow {\n    box-shadow: none !important;\n  }\n  .ai_bg_card{\n    background: @white-transparent-10 !important;\n    color: #fff !important;\n    a{\n      color: #fff !important;\n    }\n  }\n  .btn.transparent-bgcolor, .service__chips__btn, .suggestions_btn{\n    background: transparent !important;\n    color: #fff !important;\n    border: 1px solid @white-transparent-70 !important;\n  }\n  .v-slick-slide-group .transparent-bgcolor {\n    background: @black-transparent-20 !important;\n    color: #fff !important;\n    border: 0px solid @white-transparent-70 !important;\n  }\n\n}\n",".overlay_section {\n  position: fixed;\n  height: 100%;\n  z-index: 9;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n}\n#MessageContainer {\n  resize: none;\n}\n.gap-lg-2 {\n  gap: 20px;\n}\n.gap-lg-1 {\n  gap: 10px;\n}\n.ask_ai input::placeholder {\n  font-size: 1rem;\n  font-weight: 500;\n}\n.ask_ai #MessageContainer {\n  height: 4rem;\n  font-size: 16px;\n  color: #000;\n}\n.ask_ai #chat__bodyview .primaryicon-right-arrow,\n.ask_ai #chat__bodyview .primaryicon-left-arrow {\n  width: 20px;\n  height: 43px;\n  border-radius: 3px;\n  margin: 0;\n  padding: 5px !important;\n  font-size: 12px;\n  z-index: 99;\n  position: absolute;\n}\n.ask_ai #chat__bodyview .primaryicon-right-arrow {\n  right: -20px !important;\n}\n.ask_ai #chat__bodyview .primaryicon-left-arrow {\n  left: -20px !important;\n}\n.ask_ai #chat__bodyview .v-slick-slider em[disabled=false] {\n  display: none !important;\n}\n.ask_ai #chat__bodyview .v-slick-dots li button:before {\n  font-size: 16px;\n}\n.ask_ai p {\n  font-size: 14px;\n}\n.ask_ai .shadow-sm {\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px !important;\n}\n.ask_ai .strip_input {\n  font-weight: bold;\n}\n.ask_ai .svg_icon svg {\n  height: auto !important;\n}\n.ask_ai .transparent-bgcolor {\n  background: rgba(0, 0, 0, 0.2) !important;\n}\n.ask_ai .transparent-bg {\n  background: rgba(255, 255, 255, 0.1) !important;\n}\n.ask_ai .transparent-bgcolor-light {\n  background: rgba(0, 0, 0, 0.1) !important;\n}\n.ask_ai .gradient_text_white {\n  color: #fff !important;\n}\n.ask_ai .cursor_pointer {\n  cursor: pointer !important;\n}\n.ask_ai .rounded_10 {\n  border-radius: 10px !important;\n}\n.ask_ai .primary-close-circle_icon {\n  width: 35px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ask_ai .primary-close-circle_icon em {\n  top: 0;\n}\n.ask_ai .footer_icon {\n  font-size: 13px;\n  padding: 7px 16px;\n}\n.ask_ai .footer_icon.rounded-buttons {\n  font-family: inherit !important;\n  font-weight: normal !important;\n}\n.ask_ai .footer_icon:hover {\n  background: #fff !important;\n  transition: all 0.3s ease;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n}\n.ask_ai .footer_icon:hover .hover_black {\n  color: #000 !important;\n}\n.ask_ai div[disabled=true] {\n  opacity: 0.9;\n  pointer-events: none;\n}\n.border_horizontal {\n  width: 1px;\n  height: 2.5rem;\n  background: #000;\n  display: block;\n}\n.expandable-content {\n  flex-grow: 1;\n  background: #f9f9f9;\n  border-radius: 0 0;\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  left: 0;\n  right: 0;\n  height: calc(100vh - 100px);\n  z-index: 98;\n  max-width: 75%;\n  margin: auto;\n}\n.classicDesign .conversation_container,\n.classicDesign .chat_input_container {\n  width: 70%;\n  margin: auto;\n}\n.classicDesign .chat_input_container {\n  margin-top: 15px;\n}\n.expand-enter-active,\n.expand-leave-active {\n  transition: height 0.5s ease, opacity 0.5s ease;\n  overflow: hidden;\n}\n.expand-enter,\n.expand-leave-to {\n  height: 0;\n  opacity: 0;\n}\n.conversation_container {\n  overflow-y: auto;\n}\n.chat_input_container {\n  background: #fff;\n  margin-bottom: 10px;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n  border-radius: 15px;\n  padding: 10px;\n}\n.custom_box_shadow {\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n  z-index: 1;\n}\n.send_icon {\n  height: 40px;\n  width: 40px;\n  border-radius: 7px;\n  font-size: 17px;\n}\n.send_icon em {\n  display: inline;\n  color: #fff;\n  transform: rotate(270deg);\n}\n.cursor_pointer {\n  cursor: pointer;\n}\n.close_icon_container {\n  right: 15px;\n  z-index: 9;\n}\n.service__types__btn h6 {\n  font-size: 12px;\n}\n@media (min-width: 1920px) and (max-width: 2399px) {\n  .ask_ai .strip_input {\n    font-size: 26px !important;\n  }\n  .ask_ai p {\n    font-size: 17px !important;\n  }\n  .ask_ai .footer_icon {\n    font-size: 13px !important;\n    padding: 7px 16px;\n  }\n  .service__types__btn h6 {\n    font-size: 15px;\n  }\n}\n.footer_icon {\n  background: #eee;\n  font-size: 12px;\n}\n.send_container {\n  gap: 15px;\n}\n.bar-slide-enter-active,\n.bar-slide-leave-active,\n.window-slide-enter-active,\n.window-slide-leave-active,\n.input-slide-enter-active,\n.input-slide-leave-active {\n  transition: transform ease;\n}\n.bar-slide-enter-active,\n.bar-slide-leave-active {\n  transition-duration: 0.4s;\n}\n.window-slide-enter-active,\n.window-slide-leave-active {\n  transition-duration: 0.5s;\n}\n.input-slide-enter-active,\n.input-slide-leave-active {\n  transition-duration: 0.3s;\n}\n.bar-slide-enter-from,\n.bar-slide-leave-to,\n.window-slide-enter-from,\n.window-slide-leave-to {\n  transform: translateY(-100%);\n}\n.bar-slide-enter-to,\n.bar-slide-leave-from,\n.window-slide-enter-to,\n.window-slide-leave-from,\n.input-slide-enter-to,\n.input-slide-leave-from {\n  transform: translateY(0);\n}\n.input-slide-enter-from,\n.input-slide-leave-to {\n  transform: translateY(100%);\n}\n.primary-close-circle_icon {\n  border-radius: 24px;\n  border: 0;\n  padding: 8px 10px;\n  font-size: 10px;\n  text-align: center;\n  display: inline-block;\n}\n.arrow_down {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n}\n.arrow_down em {\n  transform: rotate(90deg);\n}\n.voice-animation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10px;\n}\n.c_border {\n  border: 1px solid #f9f9f9;\n}\n.is_gradient .custom_box_shadow {\n  box-shadow: none !important;\n}\n.is_gradient .ai_bg_card {\n  background: rgba(255, 255, 255, 0.1) !important;\n  color: #fff !important;\n}\n.is_gradient .ai_bg_card a {\n  color: #fff !important;\n}\n.is_gradient .btn.transparent-bgcolor,\n.is_gradient .service__chips__btn,\n.is_gradient .suggestions_btn {\n  background: transparent !important;\n  color: #fff !important;\n  border: 1px solid rgba(255, 255, 255, 0.7) !important;\n}\n.is_gradient .v-slick-slide-group .transparent-bgcolor {\n  background: rgba(0, 0, 0, 0.2) !important;\n  color: #fff !important;\n  border: 0px solid rgba(255, 255, 255, 0.7) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
